import { useTimezone } from '@/hooks/useTimezoneContext'
import dayjs from '@/lib/dayjs'
import { Typography } from '@/components/ui/typography'

interface TimezoneInfoProps {
  className?: string
  tz?: string
}

const TimezoneInfo = ({ className, tz }: TimezoneInfoProps) => {
  const { timezone } = useTimezone()

  return (
    <Typography variant="caption" className={className}>
      * All dates and times are in {dayjs.getTimezoneName(tz || timezone)}
    </Typography>
  )
}

export default TimezoneInfo
